export default class UnableToProcessBookingStageTwoError extends Error {
	constructor() {
		super(
			"Please check your verification code, otherwise contact the clinic for assistance."
		);
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
